import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findUser } from '../actions/users';
import withUser from './withUser';

const userPage = (DecoratedComponent) => {
  class UserPage extends Component {
    componentDidMount() {
      this.fetchUser();
    }

    componentDidUpdate(oldProps) {
      if (this.props.userId !== oldProps.userId) {
        this.fetchUser();
      }
    }

    fetchUser() {
      const { findUser, userId } = this.props;
      findUser(userId);
    }

    render() {
      const { children, findUser, ...props } = this.props;
      return React.createElement(DecoratedComponent, props, children);
    }
  }

  const mapDispatchToProps = {
    findUser,
  };

  UserPage = withUser(connect(null, mapDispatchToProps)(UserPage));

  return UserPage;
};

export default userPage;
